import React, { useEffect, useState } from "react"
import { RiDeleteBin4Fill } from "react-icons/ri"

const FormAttribute = (props: any) => {
    const { attribute, removeAttributeHandler, attributes, setAttributes } = props
    const [attributeKey, setAttributeKey] = useState("")
    const [attributeValue, setAttributeValue] = useState("")


    //Synced even when a value comes back empty, the earlier guard kept showing the old
    //text after an attribute was cleared and saved
    useEffect(() => {
        setAttributeKey(attribute?.attributeKey || "")
        setAttributeValue(attribute?.attributeValue ?? "")
    }, [attribute])

    useEffect(() => {
        const currentAttributeIndex = attributes.findIndex((d: any) => d.id === attribute.id)
        if (currentAttributeIndex !== -1) {
            attributes[currentAttributeIndex]["attributeValue"] = attributeValue
            setAttributes([...attributes])
        }
    }, [attributeValue])

    return (<>
        <div className="Component-creation-inner bg-white rounded  pb-[20px] mx-[15px]">
            <div className="form-field-x form-field">
                <label>{attributeKey}</label>
                <div className="flex items-center">
                    <input className="input-filled w-full" onChange={(e) => setAttributeValue(e.target.value)} value={attributeValue} type="text" />
                    <div onClick={() => removeAttributeHandler(attribute.id)} className="action-field cursor-pointer flex items-center justify-around ml-2.5">
                        <RiDeleteBin4Fill />
                        <span className="btn-tip">Remove this attribute, click Save to apply it</span>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default FormAttribute